enum FeatureFlag {
  Activities = 'activities',
  EmailVerification = 'email_verification',
  RouteAnimation = 'route_animation',
  IndoorMapping = 'indoor_mapping',
  AIChatbot = 'ai_chat_bot',
}

export default FeatureFlag;